import { CommonModule, DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/module.d-CnjH8Dlt';
import { ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DateAdapter, MAT_DATE_FORMATS, MAT_NATIVE_DATE_FORMATS } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router, RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import moment from 'moment';
import { PdfJsViewerComponent, PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { Editor, NgxEditorComponent, Toolbar, NgxEditorMenuComponent } from 'ngx-editor';
import Swal from 'sweetalert2';
import { BalanceSheetModel } from '../../../Data/Models/Balancesheet/balance-sheet-model';
import { BaseEntityModel } from '../../../Data/Models/Common/base-entity-model';
import { Email_Configuration_Model } from '../../../Data/Models/Email_Configuration_Model/Email_Configuration_Model';
import { RolesModel } from '../../../Data/Models/Users/roles-model';
import { MaterialModule } from '../../../material.module';
import { UsermanagementService } from '../../../services/apps/usermanagement/usermanagement.service';
import { Email_Configuration_Service } from '../../../services/Email_Configuration_Service/Email_Configuration_Service';
import { MessageServiceService } from '../../../Shared/common/message-service.service';
import { CustomDateAdapter } from '../../../Shared/common/ng-date-parse-adapter';
import { CharitiesService } from '../charities/services/charities.service';
import { CharityDataShareServiceService } from '../charities/services/charity-data-share-service.service';
import { ReportsService } from '../reports/reports.service';
import { TrailBalanceService } from '../trailbalance/trail-balance.service';
import { BalanceSheetapiService } from './balance-sheetapi.service';

@Component({
  selector: 'app-balancesheet',
  imports: [TablerIconsModule, MaterialModule, CommonModule, MatDatepickerModule, RouterModule, PdfJsViewerModule, NgxEditorComponent, ReactiveFormsModule, NgxEditorMenuComponent, MatCheckboxModule, MatInputModule, MatFormFieldModule],
  templateUrl: './balancesheet.component.html',
  styleUrl: './balancesheet.component.scss'
})
export class BalancesheetComponent implements OnInit {
  ShowSpinner: boolean;
  IsFirstAccountingPeriod: boolean = false
  FinancialYear: any
  editor1: Editor;
  currentPeriodEnd: any
  isDataRow = (index: number, row: any) => row.nameType === 'Data';
  isHeaderRow = (index: number, row: any) => row.nameType === 'Header';
  isSubHeaderRow = (index: number, row: any) => row.nameType === 'Header';
  isfooterrow = (index: number, row: any) => row.nameType === 'Footer';
  showAgeColumn: boolean = true;
  @ViewChild('pdfViewerAutoLoad', { static: false }) pdfViewerAutoLoad: PdfJsViewerComponent
    Downloadreportname: string;
    pdfFile: string;
    PeriodID: any;
    UserId: any;
    CentralUser: any;
  charityId: any;
  apFinalised: boolean = false
  UserRoleAccess: RolesModel
  BalanceSheetform: FormGroup;
  ispreview: boolean = false;
  CurrentUserName: string;
  SubmissionStatus: any;
  ShowSpinner2: boolean = false;
  constructor(private apiservice: BalanceSheetapiService, private router: Router, private trailBalanceService: TrailBalanceService, public dialog: MatDialog, private reportservice: ReportsService, private dataShareService: CharityDataShareServiceService, public Charities_Service: CharitiesService, private fb: FormBuilder, private emailConfigService: Email_Configuration_Service, private msgService: MessageServiceService, private _UsermanagementService: UsermanagementService, private sharedService: CharityDataShareServiceService) {
    var parsedUser1: any = localStorage.getItem('currentUser');
    const parsedUser = JSON.parse(parsedUser1);
    this.CurrentUserName = `${parsedUser.firstName} ${parsedUser.lastName}`;

  }
  isTrailBalancesaved() {
    this.trailBalanceService.isTrailBalancesaved(localStorage.getItem('currentPeriod')).subscribe((Response: any) => {
      this.ispreview = Response
    })
  }
  ngOnInit() {
    this.isTrailBalancesaved()
    this.editor1 = new Editor();
    this.GetUserAccess()
    this.IsFirstAccountingPeriod = localStorage.getItem('IsFirstAccountingPeriod')=='true'
    this.FinancialYear = localStorage.getItem('FY_Year')   
    this.GetBalanceSheetTemplate()
    this.PeriodID = localStorage.getItem('currentPeriod')
    this.UserId = localStorage.getItem('userID')
    this.CentralUser = localStorage.getItem('CentralUserId')
    this.charityId = localStorage.getItem('currentCharityID')
    this.createBalanceSheetTemplate()
    //this.dataShareService.finalStatus$.subscribe((value: any) => {
    //  this.apFinalised = value != '' && value == 'Completed'
    //})
    this.SubmissionStatus = localStorage.getItem('SubmissionStatus');
  }

  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];


  ifCCorBCCSOFA: boolean = false;

  SOFAformmailtoCC() {
    debugger
    this.ifCCorBCCSOFA = !this.ifCCorBCCSOFA;
    if (!this.ifCCorBCCSOFA) {
      this.BalanceSheetform.controls['cc'].reset();
      this.BalanceSheetform.controls['bcc'].reset();
    }
  }

 
  GetUserAccess() {
    this._UsermanagementService.GetUserRoleAccess(localStorage['userID']).subscribe(data => {
      debugger
      if (data.entity.length) {
        this.UserRoleAccess = data.entity[0]
        var submitedDate = this.UserRoleAccess.currentAPSubmitDate
      }
      this.dataShareService.finalStatus$.subscribe((value: any) => {
        this.apFinalised = value != '' && value == 'Completed'
      })
    });
  }

  disableNaviagtion() {
    document.body.classList.add('disable')
  }
  enableNavigation() {
    document.body.classList.remove('disable')
  }

  transactions: BalanceSheetModel[]
  displayedColumns2: string[]
  GetBalanceSheetTemplate() {
    debugger
    this.disableNaviagtion()
    this.ShowSpinner2 = true;
    var id = localStorage.getItem('currentPeriod')
    this.apiservice.getBalanceSheet(id).subscribe((Data: any) => {
      this.ShowSpinner2 = false;
      this.enableNavigation()
      this.transactions = Data.entity;     
      this.currentPeriodEnd = moment(Data.entity[0]?.currentPeriodEnd, 'YYYY-MM-DD HH:mm:ss').format("DD-MM-YYYY")
      if (Data.entity[0].isFundTrack) {
        if (this.IsFirstAccountingPeriod) {
          this.displayedColumns2 = ["id", "Note", "Unrestricted (£)", "Restricted (£)", "Endowment(£)", "Total This Year(£)", "Total Last Year(£)"];
        }
        else {
          this.displayedColumns2 = ["id", "Note", "Unrestricted (£)", "Restricted (£)", "Endowment(£)", "Total This Year(£)"];
        }
      }
      else {
        if (this.IsFirstAccountingPeriod) {
          this.displayedColumns2 = ["id", "Note", "Total This Year(£)", "Total Last Year(£)"];
        }
        else {
          this.displayedColumns2 = ["id", "Note", "Total This Year(£)"];
        }
      }

    })
  }
  backToCharityOverView() {
    
      localStorage.setItem('isFromBasicInfo', 'true')
      this.router.navigate(['/charity']);   
  }

  getUnrestrictedbsocst(): any {
    return this.transactions
      .map((t:any) => t.unrestricted)
      .reduce((acc:any, value:any) => acc + value, 0);
  }

  restricted(): any {
    return this.transactions
      .map((t:any) => t.restricted)
      .reduce((acc: any, value: any) => acc + value, 0);
  }

  2(): any {
    return this.transactions
      .map((t:any) => t.endowment)
      .reduce((acc: any, value: any) => acc + value, 0);
  }

  3(): any {
    return this.transactions
      .map((t:any) => t.total_This_Year)
      .reduce((acc: any, value: any) => acc + value, 0);
  }

  4(): any {
    return this.transactions
      .map((t:any) => t.total_Last_Year)
      .reduce((acc: any, value: any) => acc + value, 0);
  }
  Back() {
    this.router.navigate(['/financialactivities'])
  }
  next() {
    
    this.router.navigate(['Accountnotes']);
  }
  PreviewSOFA(template: any) {
    debugger
    this.disableNaviagtion()
    this.ShowSpinner = true
    this.reportservice.GetBalanceSheet(this.PeriodID, this.UserId, this.CentralUser, this.charityId, localStorage.getItem('fund_Tracking')).subscribe((data: any) => {
      this.ShowSpinner = false
      const byteCharacters = atob(data.Item1.toString());
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      this.pdfFile = URL.createObjectURL(blob);

      this.Downloadreportname = "BalanceSheet_Report.pdf";
      this.dialog.open(template, {
        width: '50%', maxWidth: '100%', maxHeight: 'auto', height: 'auto', disableClose: true
      });
      setTimeout(() => {
        if (this.pdfViewerAutoLoad) {
          this.pdfViewerAutoLoad.pdfSrc = this.pdfFile;
          this.pdfViewerAutoLoad.downloadFileName = this.Downloadreportname;
          this.pdfViewerAutoLoad.page = 1;
          this.pdfViewerAutoLoad.refresh();
        }
      }, 1000)
      this.ShowSpinner = false
      this.enableNavigation()
    })
  }
  createBalanceSheetTemplate() {
    this.BalanceSheetform = this.fb.group({
      emailTemplateId: [0],
      emailType: ['BalanceSheet'],
      from: [{ value: this.RetriveEmailConfigdata?.senderEmail, disabled: true }],
      //cc: ['', [Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/)]],
      //bcc: ['', [Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/)]],
      //pattern to allow multiple emails.
      cc: ['', [Validators.pattern(/^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})(;\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})*$/)]],
      bcc: ['', [Validators.pattern(/^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})(;\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})*$/)]],

      ccCheckbox: [false],
      subject: ['', Validators.required],
      Body: ['', [Validators.maxLength(500)]],
      charityName: [''],
      charityID: [+localStorage.getItem('charityId')!],
      financialPeriodsID: [+localStorage.getItem('currentPeriod')!],
      createdby: [0],
      modifiedby: [0],
      centralUserId: [+localStorage.getItem('CentralUserId')!],
      userId: [+localStorage.getItem('CurrentuserID')!],
      fund_Tracking: [localStorage.getItem('fund_Tracking') === 'true'],
      //fund_Tracking:[+localStorage.getItem('fund_Tracking')!],
      to: [
        '',
        [Validators.required, Validators.pattern(/^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})(;\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})*$/)]
      ],
    });
    this.ifCCorBCCSOFA = false
    this.BalanceSheetform.get('Body')?.valueChanges.subscribe(value => {

      const plainText = value?.replace(/<[^>]*>/g, '') || '';
      if (plainText.length > 2500) {
        const trimmedText = plainText.substring(0, 2500);
        const safeHtml = `<p>${trimmedText}</p>`;
        this.BalanceSheetform.get('Body')?.setValue(safeHtml, { emitEvent: false });
      }
    });
  }

  removeNotes(value: string): string {
    if (!value) return '';
    return value.replace(/\(Note.*?\)/g, '').trim();
  }

  sendmail() {
    debugger
    if (this.BalanceSheetform.valid) {
      this.PeriodID = +this.PeriodID
      this.UserId = +this.UserId
      this.CentralUser = +this.CentralUser
      this.charityId = +this.charityId
      this.apiservice.sentmail(this.BalanceSheetform.getRawValue()).subscribe((Data: any) => {
        debugger
        var reponse = Data;
        if (reponse == "BalanceSheetEmailResponse") {
          Swal.fire({
            html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Mail Server details not configured!</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Please configure Mail Server setting to send an email..',
            iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
            confirmButtonText: "OK",

            allowOutsideClick: false
          }).then((result) => {
            if (result.value) {
            } else {
              return
            }
          })
        }
        else if (reponse == "BalanceSheetTemplateresponse") {
          Swal.fire({
            html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Please complete the Preference</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Preference need to be done.',
            iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
            confirmButtonText: "OK",
            allowOutsideClick: false
          }).then((result) => {
            if (result.value) {
            } else {
              return
            }
          })
        } else if (reponse == "mail_sent") {
          debugger
          this.dialog.closeAll()
          this.msgService.showToastMessage("success", "Mail sent successfully");
        }
      })
    } else {
      this.BalanceSheetform.markAllAsTouched()
    }
  }
  RetriveEmailConfigdata: any
  RetriveEmailConfig(emailtemplate?: any) {
    debugger
    var Central_UserId = parseInt(localStorage.getItem('CentralUserId') || '0');
    this.emailConfigService.RetriveEmailConfig(Central_UserId).subscribe((data: BaseEntityModel<Email_Configuration_Model>) => {
      if (data.status === 0) {
        if (data.message == "Successfully, retrieved email server info") {
          if (data.entity != null && data.entity.length > 0) {
            this.RetriveEmailConfigdata = data.entity[0];
            this.BalanceSheetform.controls['from'].setValue(this.RetriveEmailConfigdata?.senderEmail)
            this.BalanceSheetform.controls['to'].markAsUntouched()
            this.dialog.open(emailtemplate, {
              width: '50%', maxWidth: '100%', maxHeight: 'auto', height: 'auto', disableClose: true
            });
            this.GetBalanceSheetTemplatedata()
              
          } else {
            Swal.fire({
              html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Mail Server details not configured!</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Please configure Mail Server setting to send an email..',
              iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
              confirmButtonText: "OK",
              allowOutsideClick: false
            }).then((result) => {
              if (result.value) {
              } else {
                return
              }
            })
            //this.toastr.error(data.message);

          }
        } else {
        }
      } else {
        Swal.fire({
          html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Mail Server details not configured!</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Please configure Mail Server setting to send an email.',
          iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
          confirmButtonText: "OK",
          allowOutsideClick: false
        }).then((result) => {
          if (result.value) {
          } else {
            return
          }
        })
        //t//his.toastr.error(data.message);
      }
    }, (error: HttpErrorResponse) => {
      //this.toastr.error(error.statusText);
    })

  }
  GetBalanceSheetTemplatedata() {
    debugger;
    this.Charities_Service.GetEmailTemplate(this.BalanceSheetform.controls['centralUserId'].value, this.BalanceSheetform.controls['emailType'].value).subscribe({
      next: (data: any) => {
        debugger;
        if (data.entity != null && data.entity[0].emailTemplateId != null) {
          data.entity[0].body = data.entity[0].body.replace('[UserName]', this.CurrentUserName)

          data.entity[0].subject = data.entity[0].subject.replace('[CharityName]', localStorage.getItem('charity_Name'))
          data.entity[0].charityName = localStorage.getItem('charity_Name')
          data.entity[0].subject = data.entity[0].subject.replace('[CN]', localStorage.getItem('charity_Registration_Number'))
          data.entity[0].body = data.entity[0].body.replace('[CharityName]', localStorage.getItem('charity_Name'))
          data.entity[0].body = data.entity[0].body.replace('[CN]', localStorage.getItem('charity_Registration_Number'))
          this.BalanceSheetform.patchValue(data.entity[0])
          this.BalanceSheetform.controls['Body'].setValue(data.entity[0].body)
          this.ifCCorBCCSOFA = data.entity[0].ccCheckbox;
          this.BalanceSheetform.controls['charityID'].setValue(+localStorage.getItem('charityId')!)
          this.BalanceSheetform.controls['financialPeriodsID'].setValue(+localStorage.getItem('currentPeriod')!)
          this.BalanceSheetform.controls['fund_Tracking'].setValue(localStorage.getItem('fund_Tracking') === 'true')
        }
        else {
          this.createBalanceSheetTemplate()
        }
        this.BalanceSheetform.markAsPristine()
        this.BalanceSheetform.controls['from'].setValue(this.RetriveEmailConfigdata?.senderEmail)
      },
      error: (err: any) => {
        console.error('Error fetching BalanceSheetform details:', err);
      }
    });
  }

  closeEmail() {
    debugger
    if (this.BalanceSheetform.dirty == true) {
      Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.BalanceSheetform.markAsUntouched()
          this.BalanceSheetform.markAsPristine()
          this.BalanceSheetform.controls['to'].markAsUntouched()
          this.dialog.closeAll()
        }
        else {
          return

        }
      })
    } else {
      this.BalanceSheetform.markAsUntouched()
      this.BalanceSheetform.markAsPristine()
      this.BalanceSheetform.controls['to'].markAsUntouched()
      this.dialog.closeAll()
    }
    
  }
  sendMailTemplate(emailtemplate: any) {
    this.RetriveEmailConfig(emailtemplate)
  }
  isBodyEmpty(formname?: any): boolean {
    const rawHtml = formname.get('Body')?.value || '';
    const strippedText = rawHtml.replace(/<[^>]*>/g, '').trim();
    return strippedText === '';
  }
  CanDeactivate(): any {

    // alert('ok')

    if (this.BalanceSheetform.dirty==true) {
        return Swal.fire({
          html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
          iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
          confirmButtonText: "Leave",
          showCancelButton: true,
          cancelButtonText: "Stay",
          allowOutsideClick: false,
          reverseButtons: true
        }).then((result) => {
          if (result.isConfirmed) {
            this.dialog.closeAll()
          
          } else {
          
           
          }
        })
      } else {
      this.dialog.closeAll()
      }
   
  }

  UnlockandAmend() {
    debugger
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Amend) {
      Swal.fire({
        html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Are you sure?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px; padding-right: 30px !important;"> Unlocking the accounting period will allow you to amend the filed accounts and correct any errors. After making any changes, the accounts must be submitted again as an Amended filing. Do you want to unlock and amend the accounting period?</p>`,
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this._UsermanagementService.UnfreezeAP(+fid,'UnlockandAmend').subscribe((data: any) => {
            debugger
            this.sharedService.setFinalStatus('InCompleted');
            localStorage.setItem('apFinalised', 'InCompleted')
            localStorage.setItem('NewAmendCycle', 'true');
          })
          //this.save("FinaliseandClose");
        }
        else { }
      })
    }
    else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }
  }
  UnfreezeAP() {
    debugger
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Submit) {
      Swal.fire({
        html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Are you sure?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px; padding-right: 30px !important;"> Do you want to unlock the Accounting Period? </p>`,
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this._UsermanagementService.UnfreezeAP(+fid,'Unlock').subscribe((data: any) => {
            debugger
            const message = "Accounting Period unlocked successfully";
            this.msgService.showToastMessage('success', message)
            this.sharedService.setFinalStatus('InCompleted');
            localStorage.setItem('apFinalised', 'InCompleted')
          })
        }
      })
    } else { 
    Swal.fire({
      html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
      iconHtml: '<span class="fa fa-warning"></span>',
      confirmButtonText: "OK",
      allowOutsideClick: false
    })
  }
  }
  gotoSubmissions() {
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Submit) {
      this._UsermanagementService.GoToSubmissions()
    } else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }

  }

}

//export interface Transaction {
//  account_Name: string;
//  unrestricted: number;
//  note: string;
//  restricted: number;
//  endowment: number; total_This_Year: number; total_Last_Year: number;
//  nameType: any;
//}


